<ng-container *ngIf="loadingData">
    <div class="skeleton skeleton-table-row" style="height: 50px;"></div>
    <div class="skeleton skeleton-table-row" *ngFor="let i of [0,0,0,0,0,0,0,0,0,0,0]"></div>
</ng-container>

<ng-container *ngIf="!loadingData">

    <dx-data-grid 
    *ngIf="showACAdmin"
        id="publishHistoryGrid"
        class="grid-with-header"
        [dataSource]="activityList"
        [allowColumnResizing]="true" 
        [columnResizingMode]="'widget'" 
        [hoverStateEnabled]="true"
        [rowAlternationEnabled]="true" 
        [columnAutoWidth]="true" 
        [allowColumnReordering]="true"
        noDataText="No records Found!"
    >
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button
                        *ngIf="!disACAdmin"
                        icon="refresh"
                        hint="Refresh"
                        (click)="fetchActivityData()"
                    ></dx-button>
                </div>
            </dxi-item>
        </dxo-toolbar>

        <dxo-scrolling mode="virtual" [showScrollbar]="'always'"></dxo-scrolling>
        
        <ng-container *ngFor="let column of displayColumns">
            <dxi-column 
                [dataField]="column.dataField" 
                [dataType]="column.dataType"
                [caption]="column.caption" 
                [format]="column.format"
                >
            </dxi-column>
        </ng-container>

    </dx-data-grid>

</ng-container>

<app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>